export default __webpack_public_path__ + "static/media/qlue.a5f4710c.svg";